import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b6f3556"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "text-name" }
const _hoisted_5 = { key: 1 }

import { t } from '@/plugins/i18n'

import AppLink from '@/components/common/AppLink.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  image: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  url: {
    type: String,
    default: ''
  },
  errorCode: {
    type: Number,
    default: 0
  },
  showStatus: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{disabled:__props.showStatus},'flex-center']),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_el_popover, {
      placement: "top-start",
      width: "168",
      "popper-class": "shopping-preview",
      trigger: "hover",
      "hide-after": 30
    }, {
      reference: _withCtx(() => [
        (__props.url)
          ? (_openBlock(), _createBlock(AppLink, {
              key: 0,
              to: __props.url,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  referrerPolicy: "no-referrer",
                  class: "image name",
                  src: __props.image,
                  alt: __props.name
                }, null, 8, _hoisted_2)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              referrerPolicy: "no-referrer",
              class: "image name",
              src: __props.image,
              alt: __props.name
            }, null, 8, _hoisted_3))
      ]),
      default: _withCtx(() => [
        _createElementVNode("img", {
          referrerPolicy: "no-referrer",
          class: "image-preview image-preview-name",
          src: __props.image,
          alt: __props.name
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (__props.name)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "name",
            style: _normalizeStyle({ '-webkit-line-clamp': __props.showStatus ? 1 : 2 })
          }, [
            (__props.url)
              ? (_openBlock(), _createBlock(AppLink, {
                  key: 0,
                  to: __props.url,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(__props.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.name), 1))
          ], 4))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})